// extracted by mini-css-extract-plugin
export var buttons = "_b7-0";
export var buttonsActive = "_b7-h";
export var cancelConfirm = "_b7-1";
export var closeButton = "_b7-2";
export var column = "_b7-3";
export var container = "_b7-4";
export var detailHeader = "_b7-6";
export var detailTitle = "_b7-7";
export var detailsContent = "_b7-5";
export var header = "_b7-8";
export var headerWithClose = "_b7-9";
export var icon = "_b7-a";
export var infoIcon = "_b7-c";
export var informationContainer = "_b7-b";
export var sideDrawer = "_b7-d";
export var sideDrawerOpen = "_b7-e";
export var stickyFooter = "_b7-f";
export var typeOption = "_b7-g";